import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { useFormikContext } from 'formik'
import { Box, Button, Collapse, FormControlLabel, Switch, Typography } from '@mui/material'
import { useTheme } from '@mui/material'
import { css } from '@emotion/css'

import { ETranslationNs, IFinishUserSignup } from 'src/types'

import { useStyles } from '../styles'
import { FONTS, TERMS_AND_CONDITIONS_URL } from 'src/constants'
import { AuthPasswordInput } from 'src/components/auth'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { Loader } from 'src/components/loader'
import { TextInputWithHelper } from 'src/components/text-input-with-helper-icon'
import { getEncodedQueryParam } from 'src/common/utils'
import { BusinessCard } from '../v2/AgreementStep/BusinessCard'

const SignupFinishForm = () => {
  const [t] = useTranslation()
  const [searchParams] = useSearchParams()
  const { errors, values, handleChange, isSubmitting } = useFormikContext<IFinishUserSignup>()
  const theme = useTheme()

  const classes = useStyles()
  // const email = getEncodedQueryParam('email')
  const withoutAccount = searchParams.get('without_account')
  const withPassword = searchParams.get('with_password')

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        width: '100%',
      }}
    >
      <BusinessCard handleChange={handleChange} value={values.buisness}>
        <Collapse sx={{ width: '100%', py: '8px' }} in={!withoutAccount && values.buisness}>
          <TextInputWithHelper
            fullWidth
            inputName="account_holder"
            handleChange={handleChange}
            value={values.account_holder}
            error={errors.account_holder ? t(errors.account_holder + '.v') : ''}
            inputPlaceholder={t('sign-up-finish-account-name-input-placeholder.v', {
              ns: ETranslationNs.Common,
            })}
            inputUpperLabel={
              <HelperWrapper
                t={'sign-up-finish-account-name-input-label'}
                ns={ETranslationNs.Common}
                isInputLable
                isMandatory
              />
            }
          />
        </Collapse>
      </BusinessCard>
      {/* {email && (
        <Grid item xs={12} className={classes.containerField}>
          <TextInputWithHelper
            disabled
            fullWidth
            inputName="email"
            handleChange={handleChange}
            value={values.email}
            error={errors.email ? t(errors.email + '.v') : ''}
            inputUpperLabel={
              <HelperWrapper
                t={'email-input-label'}
                ns={ETranslationNs.Common}
                isInputLable
                isMandatory
              />
            }
          />
        </Grid>
      )} */}

      {withPassword && <AuthPasswordInput />}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          width: '100%',
          ml: '15px',
        }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={values.agreement}
              name="agreement"
              color="primary"
              onChange={handleChange}
              size="small"
              sx={{
                '& .MuiSvgIcon-root': { fontSize: FONTS.SIZES.xxl },
                '&.Mui-checked': {
                  color: theme.palette.custom.primary,
                },
              }}
            />
          }
          label={
            <Typography className={classes.formControlLabel}>
              <a
                href={TERMS_AND_CONDITIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={css`
                  color: inherit;
                  text-decoration: none;
                  &:hover {
                    text-decoration: underline;
                  }
                `}
              >
                <HelperWrapper t="terms-checkbox-label" isMandatory />
              </a>
            </Typography>
          }
        />

        {/* <FormControlLabel
          control={
            <Switch
              checked={values.buisness}
              name="buisness"
              color="primary"
              id="buisness"
              onChange={handleChange}
              size="small"
              sx={{
                '& .MuiSvgIcon-root': { fontSize: FONTS.SIZES.xxl },
                '&.Mui-checked': {
                  color: theme.palette.custom.primary,
                },
              }}
            />
          }
          label={
            <Typography className={classes.formControlLabel}>
              <HelperWrapper t="register-customer-checkbox-label" />
            </Typography>
          }
        /> */}
      </Box>

      <Button
        type="submit"
        variant="contained"
        disabled={isSubmitting || !!Object.keys(errors).length}
        color="primary"
        sx={{ width: '100%', height: '46px' }}
      >
        {!isSubmitting ? <HelperWrapper t="sign-up-finish-submit-button" /> : <Loader size={30} />}
      </Button>
    </Box>
  )
}

export { SignupFinishForm }
